import { FC } from 'react'
import { ControllerRenderProps, FieldValues, UseFormStateReturn } from 'react-hook-form'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persianFa from 'react-date-object/locales/persian_fa'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import { useTranslation } from 'react-i18next'
import weekends from 'react-multi-date-picker/plugins/highlight_weekends'
import clsx from 'clsx'

const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج']

type IProps = {
  field: ControllerRenderProps<any, any>
  formState: UseFormStateReturn<FieldValues>
  lableTitle: string
  maxDate?: boolean
  minDate?: boolean
}

const DatePickerFeild: FC<IProps> = ({ field, formState, lableTitle, maxDate, minDate }) => {
  const { t } = useTranslation()
  const { name, onChange, value } = field
  const { errors } = formState

  return (
    <div className='relative w-full h-full flex flex-col'>
      <label className='text-sm mr-3 mb-2.5' htmlFor={''}>
        {lableTitle}
      </label>
      <DatePicker
        className='mb-4'
        onChange={(e: DateObject) => onChange({ target: { name, value: e?.toDate?.() } })}
        name={name}
        value={value}
        render={
          <InputIcon
            className={clsx(
              'rmdp-container',
              errors[name ?? '']?.message && errors[name ?? '']?.type ? 'is-invalid' : 'rmdp-input',
            )}
          />
        }
        maxDate={maxDate ? new Date() : ''}
        minDate={minDate ? new Date() : ''}
        weekDays={weekDays}
        calendar={persian}
        locale={persianFa}
        calendarPosition='bottom'
        arrow={false}
        plugins={[weekends()]}
        fixMainPosition
      >
        {/* <button
          onClick={() => field.onChange(new Date())}
          className='bg-gray-200  hover:bg-blue-400  text-gray-500 hover:text-white text-sm duration-300 ease-in-out py-2 px-24 rounded-lg mb-4 '
        >
          {t('today')}
        </button> */}
      </DatePicker>

      {errors[name ?? '']?.message ? (
        <p className='absolute bottom-8 text-xs mr-3 mt-2 text-red-400 bg-white px-1 rounded-lg'>
          {t(`${errors[name ?? ' ']?.message}`)}
        </p>
      ) : null}
    </div>
  )
}

export default DatePickerFeild
